<mat-card-content class="mve-detail-popup-container">
    <mat-card-header>
        <mat-toolbar color="accent" fxLayoutAlign="space-between center">
            <h2 fxFlex fxLayout="row" fxLayoutAlign="start center">
                {{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.EXPORT.TITLE' | translate}}
            </h2>
        </mat-toolbar>
    </mat-card-header>

    <div style="padding: 20px;">
        <form [formGroup]="dateRangeForm" autocomplete="off" style="width: 100%">
            <div fxLayout="column" fxFlex>
                <div>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.EXPORT.FROM' | translate}}</mat-label>
                        <input matInput formControlName="start" [matDatepicker]="start" [max]="endDate">
                        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                        <mat-datepicker #start></mat-datepicker>
                        <mat-error *ngIf="dateRangeForm.controls.start.hasError('required')">{{ 'MANDATORY'
                            |
                            translate }}</mat-error>
                        <mat-error *ngIf="dateRangeForm.controls.start.hasError('max')">{{ 'INVALID_VALUE'
                            |
                            translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.EXPORT.TO' | translate}}</mat-label>
                        <input matInput formControlName="end" [matDatepicker]="end" [min]="startDate" [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                        <mat-datepicker #end></mat-datepicker>
                        <mat-error *ngIf="dateRangeForm.controls.end.hasError('min')">{{ 'INVALID_VALUE'
                            |
                            translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>

    <mat-card-actions class="dialog-card-actions" fxLayoutAlign="end center">
        <button class="pull-right" mat-button (click)="onClickExportCommand()"
            [disabled]="!dateRangeForm.dirty || !dateRangeForm.valid || loading">
            <span *ngIf="!loading" translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.EXPORT.EXPORT</span>
            <mat-progress-spinner *ngIf="loading" mode="indeterminate" [diameter]="25" color="accent">
            </mat-progress-spinner>
        </button>

        <!-- Dialog closing -->
        <button mat-button (click)="close()" translate>CLOSE</button>
    </mat-card-actions>
</mat-card-content>